import * as React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import i18next from 'i18next';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { Formik, Field, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

import store, { AppState } from '../../../store';
import { Authentication, LoginFormPayload } from '../../../models/authentication';
import FormError from '../../../components/FormError/FormError';
import { actionLogin } from '../../../store/authentication/action';
import { HTTPStatusCode } from '../../../helpers/types';
import { PreneticsLogo } from '../../../components/PreneticsLogo/PreneticsLogo';
import { FormField } from '../../../components/FormField/FormField';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import { UserContainer, Title, BackgroundImage, UserForm, Form, FormFields, FormFooterLink } from '../../../styles/styled-components/User/User';

export interface LoginProps {
  login: (payload: LoginFormPayload) => void;
  authentication: Authentication;
}
interface LoginViewStates {
  username: string;
  password: string;
  loader: boolean;
  error?: string;
}

class Login extends React.Component<LoginProps, LoginViewStates> {

  state = {
    username: '',
    password: '',
    loader: false,
  };

  handleSubmit(values: LoginViewStates, actions: FormikHelpers<LoginViewStates>): void {
    this.setState({ loader: true });
    this.props.login({ username: values.username, password: values.password });
    store.subscribe(() => {
      if (this.props.authentication.error && this.props.authentication.error.status) {
        const statusCode = this.props.authentication.error.status;
        actions.setStatus({
          error: (statusCode === HTTPStatusCode.Unauthorized) ? 'login.signInButtonError' : 'form.generic.error',
        });
      }
      this.setState({ loader: false });
    });
  }

  render() {

    const validationSchema = Yup.object().shape({
      username: Yup.string().email('form.email.error.invalidFormat').required('form.email.error.empty'),
      password: Yup.string().min(8, 'form.password.error.min').required('form.password.error.empty'),
    });

    return (
      <UserContainer>
        <BackgroundImage />
        <UserForm>
          <Formik initialValues={this.state}
            onSubmit={(values, actions) => this.handleSubmit(values, actions)}
            validationSchema={validationSchema}>
            {({ status }) => (
              <Form method="POST">

                <PreneticsLogo />
                <Title>{i18next.t('login.title')}</Title>
                <FormError name="Login" data={status} />

                <FormFields>

                  <FormField name="username" label={i18next.t('form.email.label')} >
                    <Field name="username" className="input" maxLength={200} placeholder={i18next.t('form.email.placeholder')} />
                  </FormField>

                  <FormField name="password" label={i18next.t('form.password.label')}>
                    <Field name="password" className="input" type="password" maxLength={50} placeholder={i18next.t('form.password.placeholder')} />
                  </FormField>

                  <SubmitButton loader={this.state.loader} >
                    {i18next.t('login.signInButton')}
                  </SubmitButton>

                  <FormFooterLink>
                    <Link to="/forgot-password">{i18next.t('login.forgotPasswordButton')}</Link>
                  </FormFooterLink>

                </FormFields>
              </Form>
            )}
          </Formik>
        </UserForm>
      </UserContainer>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    authentication: state.authentication,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<undefined, undefined, AnyAction>) => {
  return {
    login: (payload: LoginFormPayload) => dispatch(actionLogin(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);